// package imports:
import React from "react";
// component imports:
import Entrypoint from "../Entrypoint";
import ViewCompanyAnswers from "../../components/DueDiligence/ViewAnswers/ViewCompanyAnswers";
import { RiskScoreDto } from "../../types/DueDiligenceTypes";

const ViewCompanyAnswersEntry: React.FC<{ customerId: string; riskscoreId: string; riskscore: RiskScoreDto, answerListId: number }> = ({
    customerId,
    riskscoreId,
    riskscore,
    answerListId
}) => {
    return (
        <Entrypoint>
            <ViewCompanyAnswers
                customerId={customerId}
                riskscoreId={riskscoreId}
                riskscore={riskscore}
                answerListId={answerListId}
            />
        </Entrypoint>
    )
};

export default ViewCompanyAnswersEntry;